<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 446.46 333.54">
    <g id="a" />
    <g id="b">
      <g id="c">
        <path
          :fill="this.$vuetify.theme.dark ? '#CECECE' : '#ffffff'"
          class="d"
          d="M400.07,0H46.39C20.81,0,0,20.81,0,46.4v240.75c0,25.58,20.81,46.39,46.39,46.39H400.07c25.58,0,46.39-20.81,46.39-46.39V46.4c0-25.59-20.81-46.4-46.39-46.4ZM46.39,21.74H400.07c8.73,0,16.37,4.6,20.75,11.47L242.42,189.48c-.18,.16-.35,.33-.52,.5-10.29,10.29-27.04,10.29-37.34,0-.17-.17-.34-.34-.52-.5L25.64,33.21c4.38-6.87,12.02-11.47,20.75-11.47ZM400.07,311.79H46.39c-13.59,0-24.65-11.06-24.65-24.64V58.71L189.46,205.62c9.35,9.21,21.57,13.81,33.78,13.81s24.41-4.6,33.76-13.81L424.71,58.71v228.44c0,13.59-11.06,24.64-24.65,24.64Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "EmailIcon",
};
</script>

<style scoped>
svg {
  width: 24px;
  height: 24px;
}
</style>
